import { render, staticRenderFns } from "./robotView.vue?vue&type=template&id=77040d3c&scoped=true"
import script from "./robotView.vue?vue&type=script&lang=js"
export * from "./robotView.vue?vue&type=script&lang=js"
import style0 from "./robotView.vue?vue&type=style&index=0&id=77040d3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77040d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77040d3c')) {
      api.createRecord('77040d3c', component.options)
    } else {
      api.reload('77040d3c', component.options)
    }
    module.hot.accept("./robotView.vue?vue&type=template&id=77040d3c&scoped=true", function () {
      api.rerender('77040d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/robotView.vue"
export default component.exports